module.exports = __webpack_public_path__ + "static/media/exampleCSV2.b25e1188.png";